import { GiftCardRequestDto } from './giftCardRequest.dto';

export class GiftCardRedeemRequestDto extends GiftCardRequestDto {
    amount: number;
    merchantId: number;
    entityId?: number;
    entityTypeId?: number;
    posDeviceId?: number;
    employeeId?: number;
}
  